import React, { useEffect, useRef, useState } from 'react'

import { styled } from '@mui/material/styles'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Label from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import ArrowForward from '@mui/icons-material/ArrowForward'

import { SectionProps, StateConfig } from '../../types/form'
import TextField from '@mui/material/TextField'

const TooltipBubble = styled(Typography)<{ active: number }>(
    ({ theme, active }) => ({
        marginLeft: '30px',
        padding: '10px 20px',
        backgroundColor: '#F2F2F2',
        position: 'relative',
        display: active ? 'block' : 'none',
        '&::before': {
            content: '""',
            bottom: '100%',
            position: 'absolute',
            borderBottom: '10px solid #F2F2F2',
            borderRight: '9px solid transparent',
            borderLeft: '9px solid transparent',
        },
    }),
)

const isActive = (value: string, values: any): boolean => {
    return values['driver_type'] === value
}

const Section2 = (props: SectionProps) => {

    const {
        handleNext,
        values,
        setValues,
        enabledStates,
    } = props

    /**
     * FORM
     */
    const formRef = useRef<HTMLFormElement>(null)
    const handleNextClick = () => {
        if (!formRef.current) {
            return
        }

        formRef.current.reportValidity()

        if (formRef.current.checkValidity()) {
            handleNext()
        }
    }

    /**
     * STATE CONFIG
     */
    const [truckerStatesEnabled, setTruckerStatesEnabled] = useState('')
    const [learnerStatesEnabled, setLearnerStatesEnabled] = useState('')

    const buildStateString = (enabledStates: StateConfig[]) => {
        if (enabledStates.length === 0) {
            return ''
        }

        return [
            enabledStates.map(state => state.code).slice(0, -1).join(', '),
            enabledStates.slice(-1)[0].code,
        ].join(' ou ')
    }

    useEffect(() => {
        setTruckerStatesEnabled(buildStateString(enabledStates.filter(state => state.trucker_enabled)))
        setLearnerStatesEnabled(buildStateString(enabledStates.filter(state => state.learner_enabled)))
    }, [enabledStates])

    /**
     * RENDER COMPONENT
     */
    return (
        <Box>
            <Typography variant={'h2'}>
                Tipo de Motorista
            </Typography>
            <FormControl>
                <RadioGroup
                    onChange={(e) => setValues({
                        ...values,
                        driver_type: e.target.value,
                    })}
                    value={values.driver_type}
                >
                    <FormControlLabel
                        value={'1'}
                        control={<Radio />}
                        label={'Motorista carreteiro'}
                    />
                    <TooltipBubble active={+isActive('1', values)}>
                        Requisitos: CNH E, experiência maior que um ano em
                        carteira de trabalho com carreta, interesse
                        em realizar viagens no Mercosul e Brasil, residir nos
                        estados de {truckerStatesEnabled}.
                    </TooltipBubble>
                    <FormControlLabel
                        value={'2'}
                        control={<Radio />}
                        label={'Motorista carreteiro APRENDIZ'}
                    />
                    <TooltipBubble active={+isActive('2', values)}>
                        Requisitos: CNH E, experiência com veículo pesado
                        (truck, ônibus, etc...), interesse em realizar
                        viagens no Mercosul, residir nos estados
                        de {learnerStatesEnabled}.
                    </TooltipBubble>
                </RadioGroup>
            </FormControl>

            <FormControl
                fullWidth
                component={'form'}
                ref={formRef}
                sx={{ mt: 5 }}
            >
                <Label>
                    Tempo de experiência
                    com {values.driver_type === '1' ? 'Carreta' : 'Truck'}
                </Label>
                <TextField
                    fullWidth
                    required={true}
                    variant={'outlined'}
                    value={values.experience_months}
                    onChange={(e) => setValues({
                        ...values,
                        experience_months: e.target.value.replace(/\D/g, ''),
                    })}
                    inputProps={{ min: 0 }}
                />
            </FormControl>

            <Stack direction={'row'} justifyContent={'end'} mt={5}>
                <Button variant={'contained'} onClick={handleNextClick}>
                    Próximo
                    <ArrowForward fontSize={'small'} sx={{ ml: 2 }} />
                </Button>
            </Stack>
        </Box>
    )
}

export default Section2